import apiService from './api';

export interface ElasticsearchIndexStats {
  totalDocs: number;
  sizeInBytes: number;
  sizeFormatted: string;
}

export interface ElasticsearchStatus {
  enabled: boolean;
  connected: boolean;
  stats: ElasticsearchIndexStats | null;
}

type ApiEnvelope<T> = {
  status?: string;
  data?: T;
  message?: string;
};

class ElasticsearchAdminService {
  private baseUrl = '/admin/elasticsearch';

  async getStatus(): Promise<ElasticsearchStatus> {
    // apiService.get برای فرمت {status, data} معمولاً data را extract می‌کند
    const data = await apiService.get<ElasticsearchStatus>(`${this.baseUrl}/status`);
    return data;
  }

  async fullSync(batchSize?: number): Promise<{ success: number; failed: number; total: number }> {
    const res = await apiService.post<ApiEnvelope<{ success: number; failed: number; total: number }>>(
      `${this.baseUrl}/sync`,
      {},
      { params: batchSize ? { batchSize } : undefined }
    );

    if (res && typeof res === 'object' && 'data' in (res as any) && (res as any).data) {
      return (res as any).data;
    }
    // Fallback اگر بک‌اند مستقیم result را برگرداند
    return res as any;
  }

  async rebuildIndex(): Promise<{ message?: string }> {
    const res = await apiService.post<ApiEnvelope<null>>(`${this.baseUrl}/rebuild`, {});
    if (res && typeof res === 'object' && 'message' in (res as any)) {
      return { message: (res as any).message };
    }
    return {};
  }

  async syncProduct(productId: string): Promise<{ message?: string }> {
    const res = await apiService.post<ApiEnvelope<null>>(`${this.baseUrl}/sync/${productId}`, {});
    if (res && typeof res === 'object' && 'message' in (res as any)) {
      return { message: (res as any).message };
    }
    return {};
  }
}

export default new ElasticsearchAdminService();


